export const isMobile = () => /Android|iPhone|iPad/gm.test(window?.navigator.userAgent);
